import TermsOfUse from '@/views/contracts/terms-of-use/TermsOfUse.vue';

export default {
  path: '/terms-of-use',
  name: 'TermsOfUse',
  component: TermsOfUse
};
